var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("TitleWithRow", { attrs: { title: "Bioinsumos" } }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: "Utiliza bioinsumo?",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              rulesInput: _vm.rules,
              opcoes: _vm.options.opcoesSimNao,
              multiSelect: false,
              widthColumn: 8
            },
            model: {
              value: _vm.pratica.utilizaBioinsumos,
              callback: function($$v) {
                _vm.$set(_vm.pratica, "utilizaBioinsumos", $$v)
              },
              expression: "pratica.utilizaBioinsumos"
            }
          }),
          _vm._v(" "),
          _vm.containsOption(_vm.pratica.utilizaBioinsumos, true, "bioinsumos")
            ? _c("InputSelect", {
                attrs: {
                  label: "Tipo(s) de bioinsumos aplicados:",
                  nomeAba: _vm.nomeAba,
                  obrigatorio: true,
                  rulesInput: _vm.rules,
                  opcoes: _vm.options.opcoesBioinsumo,
                  widthColumn: 8,
                  multiSelect: ""
                },
                model: {
                  value: _vm.bioinsumosSelecionados,
                  callback: function($$v) {
                    _vm.bioinsumosSelecionados = $$v
                  },
                  expression: "bioinsumosSelecionados"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          Array.isArray(_vm.bioinsumosSelecionados) &&
          _vm.bioinsumosSelecionados.includes("BIOFERTILIZANTES")
            ? _c("validation-provider", {
                attrs: {
                  rules: _vm.rules,
                  mode: "lazy",
                  name: _vm.nomeAba + "/Biofertilizantes/Qual(is)"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("Label", {
                                attrs: {
                                  label: "Biofertilizantes/Qual(is)?",
                                  obrigatorio: true
                                }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                class: { "input erro": errors.length },
                                attrs: { name: "Biofertilizantes/Qual(is)?" },
                                model: {
                                  value: _vm.especificacaoBiofertilizantes,
                                  callback: function($$v) {
                                    _vm.especificacaoBiofertilizantes = $$v
                                  },
                                  expression: "especificacaoBiofertilizantes"
                                }
                              }),
                              _vm._v(" "),
                              errors[0]
                                ? _c("span", { staticClass: "help erro" }, [
                                    _vm._v(" " + _vm._s(errors[0]))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2900714026
                )
              })
            : _vm._e(),
          _vm._v(" "),
          Array.isArray(_vm.bioinsumosSelecionados) &&
          _vm.bioinsumosSelecionados.includes("OUTROS")
            ? _c("validation-provider", {
                attrs: {
                  rules: _vm.rules,
                  mode: "lazy",
                  name: _vm.nomeAba + "/Outros Bioinsumos"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("Label", {
                                attrs: {
                                  label: "Outros tipos de bioinsumos:",
                                  obrigatorio: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                class: { "input erro": errors.length },
                                attrs: { name: "Outros Bioinsumos" },
                                model: {
                                  value: _vm.especificacaoOutros,
                                  callback: function($$v) {
                                    _vm.especificacaoOutros = $$v
                                  },
                                  expression: "especificacaoOutros"
                                }
                              }),
                              _vm._v(" "),
                              errors[0]
                                ? _c("span", { staticClass: "help erro" }, [
                                    _vm._v(" " + _vm._s(errors[0]))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3159492204
                )
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72e9f974", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72e9f974","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/FormulariosProntos/Bioinsumos/Bioinsumos.vue
// module id = null
// module chunks = 